module.exports = __webpack_public_path__ + "media/application/images/svgs/git-commit-bb0ef6a80ac28bea310c04afd29f47ae.svg";